// Auto-generated from WebLocalizable.xcstrings. Do not edit.
import type { I18nTranslations } from './i18n-keys';

// prettier-ignore
export const i18nTranslations = {
  'en': {
    ' and ': ' and ',
    'Accessibility': 'Accessibility',
    'Add preview': 'Add preview',
    'Add to calendar': 'Add to calendar',
    'Afternoon': 'Afternoon',
    'Afternoon, {name}': 'Afternoon, {name}',
    'Agent wants to start ComputerUse': 'Agent wants to start ComputerUse',
    'Approve': 'Approve',
    'Approved': 'Approved',
    'Apps in focus: {apps}': 'Apps in focus: {apps}',
    'Background': 'Background',
    'Book could not publish this site.': 'Book could not publish this site.',
    'Book is preparing the preview before publishing.': 'Book is preparing the preview before publishing.',
    'Cancel': 'Cancel',
    'Cancel queued message': 'Cancel queued message',
    'Cancelled': 'Cancelled',
    'Close': 'Close',
    'Close preview': 'Close preview',
    'Close share dialog': 'Close share dialog',
    'Complete login': 'Complete login',
    'Completed': 'Completed',
    'Completing…': 'Completing…',
    'ComputerUse needs {permissions}.': 'ComputerUse needs {permissions}.',
    'Copied': 'Copied',
    'Copied!': 'Copied!',
    'Copy': 'Copy',
    'Copy Code': 'Copy Code',
    'Copy Link': 'Copy Link',
    'Copy Suggestion': 'Copy Suggestion',
    'Copy URL': 'Copy URL',
    'Copy error': 'Copy error',
    'Copy failed, please try again.': 'Copy failed, please try again.',
    'Could not publish to Book': 'Could not publish to Book',
    'Create a new issue': 'Create a new issue',
    'Create an event': 'Create an event',
    'Create issue': 'Create issue',
    'Delete': 'Delete',
    'Denied': 'Denied',
    'Deny': 'Deny',
    'Download': 'Download',
    'Download Image': 'Download Image',
    'Download diagram': 'Download diagram',
    'Download diagram as MMD': 'Download diagram as MMD',
    'Download diagram as PNG': 'Download diagram as PNG',
    'Download diagram as SVG': 'Download diagram as SVG',
    'Download file': 'Download file',
    'Download image': 'Download image',
    'Duration': 'Duration',
    'End': 'End',
    'Enter {label}…': 'Enter {label}…',
    'Evening': 'Evening',
    'Evening, {name}': 'Evening, {name}',
    'Exit fullscreen': 'Exit fullscreen',
    'Expired': 'Expired',
    'Extract key points summary': 'Extract key points summary',
    'Failed to delete schedule': 'Failed to delete schedule',
    'Failed to load audio': 'Failed to load audio',
    'Failed to load image': 'Failed to load image',
    'Failed to load video': 'Failed to load video',
    'Failed to render Mermaid chart': 'Failed to render Mermaid chart',
    'Failed to save recording': 'Failed to save recording',
    'Failed to save recording ({status})': 'Failed to save recording ({status})',
    'Failed to start recording': 'Failed to start recording',
    'File list': 'File list',
    'Foreground': 'Foreground',
    'Generated image': 'Generated image',
    'Grant permissions': 'Grant permissions',
    'How can I help you today?': 'How can I help you today?',
    'Image preview': 'Image preview',
    'Image unavailable': 'Image unavailable',
    'Input Monitoring': 'Input Monitoring',
    'Interactive login': 'Interactive login',
    'Interactive login completion is not available': 'Interactive login completion is not available',
    'Invalid recording tag': 'Invalid recording tag',
    'Link Copied!': 'Link Copied!',
    'Link Suggestion': 'Link Suggestion',
    'Loading 360° preview...': 'Loading 360° preview...',
    'Loading browser view...': 'Loading browser view...',
    'Loading diagram...': 'Loading diagram...',
    'Loading share preview…': 'Loading share preview…',
    'Loading…': 'Loading…',
    'Login link expired.': 'Login link expired.',
    'Manage in Book': 'Manage in Book',
    'Markdown preview': 'Markdown preview',
    'Mermaid Error': 'Mermaid Error',
    'Mermaid chart': 'Mermaid chart',
    'Microphone recording is not supported in this environment': 'Microphone recording is not supported in this environment',
    'Morning': 'Morning',
    'Morning, {name}': 'Morning, {name}',
    'Needs attention': 'Needs attention',
    'No active recording session': 'No active recording session',
    'No audio was captured': 'No audio was captured',
    'No description': 'No description',
    'No items selected': 'No items selected',
    'No longer runs': 'No longer runs',
    'Nothing to share yet.': 'Nothing to share yet.',
    'Only supported attachments from the current assistant turn can be shared.': 'Only supported attachments from the current assistant turn can be shared.',
    'Open': 'Open',
    'Open link': 'Open link',
    'Open login': 'Open login',
    'Opening authorization…': 'Opening authorization…',
    'Pause': 'Pause',
    'Paused': 'Paused',
    'Permission request': 'Permission request',
    'Play': 'Play',
    'Playback speed': 'Playback speed',
    'Preparing a preview of the current assistant turn…': 'Preparing a preview of the current assistant turn…',
    'Preparing preview': 'Preparing preview',
    'Preparing share content': 'Preparing share content',
    'Preview': 'Preview',
    'Preview 360° image': 'Preview 360° image',
    'Preview image': 'Preview image',
    'Preview is not available for {fileName}{mimeType}.': 'Preview is not available for {fileName}{mimeType}.',
    'Published': 'Published',
    'Published to Book': 'Published to Book',
    'Publishing to Book': 'Publishing to Book',
    'Re-record': 'Re-record',
    'Recording path must end with .wav': 'Recording path must end with .wav',
    'Reset zoom and pan': 'Reset zoom and pan',
    'Result': 'Result',
    'Resume': 'Resume',
    'Retry': 'Retry',
    'Review the files before creating the share link.': 'Review the files before creating the share link.',
    'Run': 'Run',
    'Save': 'Save',
    'Save File': 'Save File',
    'Save Image': 'Save Image',
    'Save completed': 'Save completed',
    'Saved': 'Saved',
    'Saved to {path}': 'Saved to {path}',
    'Saving...': 'Saving...',
    'Schedule actions': 'Schedule actions',
    'Screen Recording': 'Screen Recording',
    'Search with Google': 'Search with Google',
    'Select a file from chat to preview it here.': 'Select a file from chat to preview it here.',
    'Sent at {time}': 'Sent at {time}',
    'Share': 'Share',
    'Share Chat': 'Share Chat',
    'Share created. Copy the public link or close this dialog.': 'Share created. Copy the public link or close this dialog.',
    'Share failed.': 'Share failed.',
    'Sharing…': 'Sharing…',
    'Show Code': 'Show Code',
    'Skipped': 'Skipped',
    'Something went wrong': 'Something went wrong',
    'Speed': 'Speed',
    'Start': 'Start',
    'Start recording': 'Start recording',
    'Started': 'Started',
    'Started in {mode} mode': 'Started in {mode} mode',
    'Stop and save recording': 'Stop and save recording',
    "This Markdown file couldn't be rendered.": "This Markdown file couldn't be rendered.",
    'This panorama is too large to preview here.': 'This panorama is too large to preview here.',
    'Toggle expand/collapse': 'Toggle expand/collapse',
    'Try reopening the file, or check whether the file is still available and encoded as readable text.': 'Try reopening the file, or check whether the file is still available and encoded as readable text.',
    'Unable to load the 360° preview.': 'Unable to load the 360° preview.',
    'Untitled Event': 'Untitled Event',
    'Untitled Issue': 'Untitled Issue',
    'Uploading files for the share link…': 'Uploading files for the share link…',
    'Use: <recording path="vm:///.../voice.wav"></recording>': 'Use: <recording path="vm:///.../voice.wav"></recording>',
    'View Artifacts': 'View Artifacts',
    'View Messages': 'View Messages',
    'View fullscreen': 'View fullscreen',
    'Waiting for a save location…': 'Waiting for a save location…',
    'Web Browse': 'Web Browse',
    'Web Browse session': 'Web Browse session',
    'Web Search': 'Web Search',
    'Your shared site is published in Book.': 'Your shared site is published in Book.',
    'Zoom in': 'Zoom in',
    'Zoom out': 'Zoom out',
    'bytes': 'bytes',
    'value': 'value',
    '{count} audio file': '{count} audio file',
    '{count} audio files': '{count} audio files',
    '{count} document': '{count} document',
    '{count} documents': '{count} documents',
    '{count} image': '{count} image',
    '{count} images': '{count} images',
    '{count} item': '{count} item',
    '{count} items': '{count} items',
    '{count} video file': '{count} video file',
    '{count} video files': '{count} video files',
    '{count} web page': '{count} web page',
    '{count} web pages': '{count} web pages',
  },
  'de': {
    ' and ': ' und ',
    'Accessibility': 'Bedienungshilfen',
    'Add preview': 'Vorschau hinzufügen',
    'Add to calendar': 'Zum Kalender hinzufügen',
    'Afternoon': 'Guten Tag',
    'Afternoon, {name}': 'Guten Tag, {name}',
    'Agent wants to start ComputerUse': 'Der Agent möchte ComputerUse starten',
    'Approve': 'Genehmigen',
    'Approved': 'Genehmigt',
    'Apps in focus: {apps}': 'Apps im Fokus: {apps}',
    'Background': 'Hintergrund',
    'Book could not publish this site.': 'Book konnte diese Website nicht veröffentlichen.',
    'Book is preparing the preview before publishing.': 'Book bereitet vor der Veröffentlichung die Vorschau vor.',
    'Cancel': 'Abbrechen',
    'Cancel queued message': 'Nachricht in Warteschlange abbrechen',
    'Cancelled': 'Abgebrochen',
    'Close': 'Schließen',
    'Close preview': 'Vorschau schließen',
    'Close share dialog': 'Freigabedialog schließen',
    'Complete login': 'Anmeldung abschließen',
    'Completed': 'Abgeschlossen',
    'Completing…': 'Wird abgeschlossen…',
    'ComputerUse needs {permissions}.': 'ComputerUse benötigt {permissions}.',
    'Copied': 'Kopiert',
    'Copied!': 'Kopiert!',
    'Copy': 'Kopieren',
    'Copy Code': 'Code kopieren',
    'Copy Link': 'Link kopieren',
    'Copy Suggestion': 'Kopiervorschlag',
    'Copy URL': 'URL kopieren',
    'Copy error': 'Fehler kopieren',
    'Copy failed, please try again.': 'Kopieren fehlgeschlagen. Bitte erneut versuchen.',
    'Could not publish to Book': 'Konnte nicht in Book veröffentlichen',
    'Create a new issue': 'Neues Issue erstellen',
    'Create an event': 'Termin erstellen',
    'Create issue': 'Issue erstellen',
    'Delete': 'Löschen',
    'Denied': 'Abgelehnt',
    'Deny': 'Ablehnen',
    'Download': 'Herunterladen',
    'Download Image': 'Bild herunterladen',
    'Download diagram': 'Diagramm laden',
    'Download diagram as MMD': 'Diagramm als MMD laden',
    'Download diagram as PNG': 'Diagramm als PNG laden',
    'Download diagram as SVG': 'Diagramm als SVG laden',
    'Download file': 'Datei laden',
    'Download image': 'Bild herunterladen',
    'Duration': 'Dauer',
    'End': 'Ende',
    'Enter {label}…': '{label} eingeben…',
    'Evening': 'Guten Abend',
    'Evening, {name}': 'Guten Abend, {name}',
    'Exit fullscreen': 'Vollbild beenden',
    'Expired': 'Abgelaufen',
    'Extract key points summary': 'Kernpunkte zusammenfassen',
    'Failed to delete schedule': 'Zeitplan konnte nicht gelöscht werden',
    'Failed to load audio': 'Audio konnte nicht geladen werden',
    'Failed to load image': 'Bild konnte nicht geladen werden',
    'Failed to load video': 'Video konnte nicht geladen werden',
    'Failed to render Mermaid chart': 'Mermaid-Diagramm konnte nicht gerendert werden',
    'Failed to save recording': 'Aufnahme konnte nicht gespeichert werden',
    'Failed to save recording ({status})': 'Aufnahme konnte nicht gespeichert werden ({status})',
    'Failed to start recording': 'Aufnahme konnte nicht gestartet werden',
    'File list': 'Dateiliste',
    'Foreground': 'Vordergrund',
    'Generated image': 'Generiertes Bild',
    'Grant permissions': 'Berechtigungen erteilen',
    'How can I help you today?': 'Wie kann ich Ihnen heute helfen?',
    'Image preview': 'Bildvorschau',
    'Image unavailable': 'Bild nicht verfügbar',
    'Input Monitoring': 'Eingabeüberwachung',
    'Interactive login': 'Interaktive Anmeldung',
    'Interactive login completion is not available': 'Abschluss der interaktiven Anmeldung ist nicht verfügbar',
    'Invalid recording tag': 'Ungültiges Aufnahme-Tag',
    'Link Copied!': 'Link kopiert!',
    'Link Suggestion': 'Linkvorschlag',
    'Loading 360° preview...': '360°-Vorschau wird geladen...',
    'Loading browser view...': 'Browseransicht wird geladen...',
    'Loading diagram...': 'Diagramm wird geladen...',
    'Loading share preview…': 'Freigabevorschau wird geladen…',
    'Loading…': 'Wird geladen…',
    'Login link expired.': 'Anmeldelink ist abgelaufen.',
    'Manage in Book': 'In Book verwalten',
    'Markdown preview': 'Markdown-Vorschau',
    'Mermaid Error': 'Mermaid-Fehler',
    'Mermaid chart': 'Mermaid-Diagramm',
    'Microphone recording is not supported in this environment': 'Mikrofonaufnahme wird in dieser Umgebung nicht unterstützt',
    'Morning': 'Guten Morgen',
    'Morning, {name}': 'Guten Morgen, {name}',
    'Needs attention': 'Aufmerksamkeit erforderlich',
    'No active recording session': 'Keine aktive Aufnahmesitzung',
    'No audio was captured': 'Es wurde kein Audio aufgenommen',
    'No description': 'Keine Beschreibung',
    'No items selected': 'Keine Elemente ausgewählt',
    'No longer runs': 'Wird nicht mehr ausgeführt',
    'Nothing to share yet.': 'Noch nichts zum Teilen.',
    'Only supported attachments from the current assistant turn can be shared.': 'Es können nur unterstützte Anhänge aus der aktuellen Assistentenantwort geteilt werden.',
    'Open': 'Öffnen',
    'Open link': 'Link öffnen',
    'Open login': 'Anmeldung öffnen',
    'Opening authorization…': 'Autorisierung wird geöffnet…',
    'Pause': 'Pausieren',
    'Paused': 'Pausiert',
    'Permission request': 'Berechtigungsanfrage',
    'Play': 'Wiedergeben',
    'Playback speed': 'Wiedergabegeschwindigkeit',
    'Preparing a preview of the current assistant turn…': 'Vorschau der aktuellen Assistentenantwort wird vorbereitet…',
    'Preparing preview': 'Vorschau wird vorbereitet',
    'Preparing share content': 'Freigabeinhalt wird vorbereitet',
    'Preview': 'Vorschau',
    'Preview 360° image': '360°-Bildvorschau',
    'Preview image': 'Bildvorschau anzeigen',
    'Preview is not available for {fileName}{mimeType}.': 'Für {fileName}{mimeType} ist keine Vorschau verfügbar.',
    'Published': 'Veröffentlicht',
    'Published to Book': 'In Book veröffentlicht',
    'Publishing to Book': 'Wird in Book veröffentlicht',
    'Re-record': 'Erneut aufnehmen',
    'Recording path must end with .wav': 'Der Aufnahmepfad muss auf .wav enden',
    'Reset zoom and pan': 'Zoom und Verschieben zurücksetzen',
    'Result': 'Ergebnis',
    'Resume': 'Fortsetzen',
    'Retry': 'Erneut versuchen',
    'Review the files before creating the share link.': 'Prüfe die Dateien, bevor du den Freigabelink erstellst.',
    'Run': 'Ausführen',
    'Save': 'Speichern',
    'Save File': 'Datei speichern',
    'Save Image': 'Bild speichern',
    'Save completed': 'Speichern abgeschlossen',
    'Saved': 'Gespeichert',
    'Saved to {path}': 'Gespeichert unter {path}',
    'Saving...': 'Speichern...',
    'Schedule actions': 'Zeitplanaktionen',
    'Screen Recording': 'Bildschirmaufnahme',
    'Search with Google': 'Mit Google suchen',
    'Select a file from chat to preview it here.': 'Wähle eine Datei aus dem Chat aus, um sie hier anzusehen.',
    'Sent at {time}': 'Gesendet: {time}',
    'Share': 'Teilen',
    'Share Chat': 'Chat teilen',
    'Share created. Copy the public link or close this dialog.': 'Freigabe erstellt. Kopiere den öffentlichen Link oder schließe diesen Dialog.',
    'Share failed.': 'Teilen fehlgeschlagen.',
    'Sharing…': 'Wird geteilt…',
    'Show Code': 'Code anzeigen',
    'Skipped': 'Übersprungen',
    'Something went wrong': 'Etwas ist schiefgelaufen',
    'Speed': 'Geschwindigkeit',
    'Start': 'Beginn',
    'Start recording': 'Aufnahme starten',
    'Started': 'Gestartet',
    'Started in {mode} mode': 'Im Modus {mode} gestartet',
    'Stop and save recording': 'Aufnahme stoppen und speichern',
    "This Markdown file couldn't be rendered.": 'Diese Markdown-Datei konnte nicht gerendert werden.',
    'This panorama is too large to preview here.': 'Dieses Panorama ist zu groß für die Vorschau hier.',
    'Toggle expand/collapse': 'Ein-/Ausklappen umschalten',
    'Try reopening the file, or check whether the file is still available and encoded as readable text.': 'Öffne die Datei erneut oder prüfe, ob sie noch verfügbar und als lesbarer Text codiert ist.',
    'Unable to load the 360° preview.': 'Die 360°-Vorschau konnte nicht geladen werden.',
    'Untitled Event': 'Unbenannter Termin',
    'Untitled Issue': 'Unbenanntes Issue',
    'Uploading files for the share link…': 'Dateien für den Freigabelink werden hochgeladen…',
    'Use: <recording path="vm:///.../voice.wav"></recording>': 'Verwendung: <recording path="vm:///.../voice.wav"></recording>',
    'View Artifacts': 'Artefakte anzeigen',
    'View Messages': 'Nachrichten anzeigen',
    'View fullscreen': 'Im Vollbild anzeigen',
    'Waiting for a save location…': 'Warte auf Speicherort…',
    'Web Browse': 'Web-Browsing',
    'Web Browse session': 'Web-Browsing-Sitzung',
    'Web Search': 'Websuche',
    'Your shared site is published in Book.': 'Deine geteilte Website wurde in Book veröffentlicht.',
    'Zoom in': 'Vergrößern',
    'Zoom out': 'Verkleinern',
    'bytes': 'Bytes',
    'value': 'Wert',
    '{count} audio file': '{count} Audiodatei',
    '{count} audio files': '{count} Audiodateien',
    '{count} document': '{count} Dokument',
    '{count} documents': '{count} Dokumente',
    '{count} image': '{count} Bild',
    '{count} images': '{count} Bilder',
    '{count} item': '{count} Element',
    '{count} items': '{count} Elemente',
    '{count} video file': '{count} Videodatei',
    '{count} video files': '{count} Videodateien',
    '{count} web page': '{count} Webseite',
    '{count} web pages': '{count} Webseiten',
  },
  'es': {
    ' and ': ' y ',
    'Accessibility': 'Accesibilidad',
    'Add preview': 'Añadir vista previa',
    'Add to calendar': 'Añadir al calendario',
    'Afternoon': 'Buenas tardes',
    'Afternoon, {name}': 'Buenas tardes, {name}',
    'Agent wants to start ComputerUse': 'El agente quiere iniciar ComputerUse',
    'Approve': 'Aprobar',
    'Approved': 'Aprobado',
    'Apps in focus: {apps}': 'Apps en foco: {apps}',
    'Background': 'Segundo plano',
    'Book could not publish this site.': 'Book no pudo publicar este sitio.',
    'Book is preparing the preview before publishing.': 'Book está preparando la vista previa antes de publicar.',
    'Cancel': 'Cancelar',
    'Cancel queued message': 'Cancelar mensaje en cola',
    'Cancelled': 'Cancelado',
    'Close': 'Cerrar',
    'Close preview': 'Cerrar vista previa',
    'Close share dialog': 'Cerrar diálogo de compartir',
    'Complete login': 'Completar inicio de sesión',
    'Completed': 'Completado',
    'Completing…': 'Completando…',
    'ComputerUse needs {permissions}.': 'ComputerUse necesita {permissions}.',
    'Copied': 'Copiado',
    'Copied!': '¡Copiado!',
    'Copy': 'Copiar',
    'Copy Code': 'Copiar código',
    'Copy Link': 'Copiar enlace',
    'Copy Suggestion': 'Sugerencia de copia',
    'Copy URL': 'Copiar URL',
    'Copy error': 'Copiar error',
    'Copy failed, please try again.': 'No se pudo copiar. Inténtalo de nuevo.',
    'Could not publish to Book': 'No se pudo publicar en Book',
    'Create a new issue': 'Crear una nueva incidencia',
    'Create an event': 'Crear un evento',
    'Create issue': 'Crear incidencia',
    'Delete': 'Eliminar',
    'Denied': 'Denegado',
    'Deny': 'Denegar',
    'Download': 'Descargar',
    'Download Image': 'Descargar imagen',
    'Download diagram': 'Descargar diagrama',
    'Download diagram as MMD': 'Descargar diagrama como MMD',
    'Download diagram as PNG': 'Descargar diagrama como PNG',
    'Download diagram as SVG': 'Descargar diagrama como SVG',
    'Download file': 'Descargar archivo',
    'Download image': 'Descargar imagen',
    'Duration': 'Duración',
    'End': 'Fin',
    'Enter {label}…': 'Introduce {label}…',
    'Evening': 'Buenas noches',
    'Evening, {name}': 'Buenas noches, {name}',
    'Exit fullscreen': 'Salir de pantalla completa',
    'Expired': 'Caducado',
    'Extract key points summary': 'Extraer resumen de puntos clave',
    'Failed to delete schedule': 'No se pudo eliminar la programación',
    'Failed to load audio': 'No se pudo cargar el audio',
    'Failed to load image': 'No se pudo cargar la imagen',
    'Failed to load video': 'No se pudo cargar el video',
    'Failed to render Mermaid chart': 'No se pudo renderizar el diagrama Mermaid',
    'Failed to save recording': 'No se pudo guardar la grabación',
    'Failed to save recording ({status})': 'No se pudo guardar la grabación ({status})',
    'Failed to start recording': 'No se pudo iniciar la grabación',
    'File list': 'Lista de archivos',
    'Foreground': 'Primer plano',
    'Generated image': 'Imagen generada',
    'Grant permissions': 'Conceder permisos',
    'How can I help you today?': '¿En qué puedo ayudarte hoy?',
    'Image preview': 'Vista previa de imagen',
    'Image unavailable': 'Imagen no disponible',
    'Input Monitoring': 'Monitoreo de entrada',
    'Interactive login': 'Inicio de sesión interactivo',
    'Interactive login completion is not available': 'La finalización del inicio de sesión interactivo no está disponible',
    'Invalid recording tag': 'Etiqueta de grabación no válida',
    'Link Copied!': '¡Enlace copiado!',
    'Link Suggestion': 'Sugerencia de enlace',
    'Loading 360° preview...': 'Cargando vista previa 360°...',
    'Loading browser view...': 'Cargando vista del navegador...',
    'Loading diagram...': 'Cargando diagrama...',
    'Loading share preview…': 'Cargando vista previa para compartir…',
    'Loading…': 'Cargando…',
    'Login link expired.': 'El enlace de inicio de sesión caducó.',
    'Manage in Book': 'Gestionar en Book',
    'Markdown preview': 'Vista previa de Markdown',
    'Mermaid Error': 'Error de Mermaid',
    'Mermaid chart': 'Diagrama Mermaid',
    'Microphone recording is not supported in this environment': 'La grabación con micrófono no es compatible con este entorno',
    'Morning': 'Buenos días',
    'Morning, {name}': 'Buenos días, {name}',
    'Needs attention': 'Requiere atención',
    'No active recording session': 'No hay una sesión de grabación activa',
    'No audio was captured': 'No se capturó audio',
    'No description': 'Sin descripción',
    'No items selected': 'No hay elementos seleccionados',
    'No longer runs': 'Ya no se ejecuta',
    'Nothing to share yet.': 'Todavía no hay nada para compartir.',
    'Only supported attachments from the current assistant turn can be shared.': 'Solo se pueden compartir adjuntos compatibles del turno actual del asistente.',
    'Open': 'Abrir',
    'Open link': 'Abrir enlace',
    'Open login': 'Abrir inicio de sesión',
    'Opening authorization…': 'Abriendo autorización…',
    'Pause': 'Pausar',
    'Paused': 'En pausa',
    'Permission request': 'Solicitud de permiso',
    'Play': 'Reproducir',
    'Playback speed': 'Velocidad de reproducción',
    'Preparing a preview of the current assistant turn…': 'Preparando una vista previa del turno actual del asistente…',
    'Preparing preview': 'Preparando vista previa',
    'Preparing share content': 'Preparando contenido para compartir',
    'Preview': 'Vista previa',
    'Preview 360° image': 'Previsualizar imagen 360°',
    'Preview image': 'Previsualizar imagen',
    'Preview is not available for {fileName}{mimeType}.': 'La vista previa no está disponible para {fileName}{mimeType}.',
    'Published': 'Publicado',
    'Published to Book': 'Publicado en Book',
    'Publishing to Book': 'Publicando en Book',
    'Re-record': 'Volver a grabar',
    'Recording path must end with .wav': 'La ruta de grabación debe terminar en .wav',
    'Reset zoom and pan': 'Restablecer zoom y paneo',
    'Result': 'Resultado',
    'Resume': 'Reanudar',
    'Retry': 'Reintentar',
    'Review the files before creating the share link.': 'Revisa los archivos antes de crear el enlace para compartir.',
    'Run': 'Ejecutar',
    'Save': 'Guardar',
    'Save File': 'Guardar archivo',
    'Save Image': 'Guardar imagen',
    'Save completed': 'Guardado completado',
    'Saved': 'Guardado',
    'Saved to {path}': 'Guardado en {path}',
    'Saving...': 'Guardando...',
    'Schedule actions': 'Acciones de programación',
    'Screen Recording': 'Grabación de pantalla',
    'Search with Google': 'Buscar con Google',
    'Select a file from chat to preview it here.': 'Selecciona un archivo del chat para previsualizarlo aquí.',
    'Sent at {time}': 'Enviado: {time}',
    'Share': 'Compartir',
    'Share Chat': 'Compartir chat',
    'Share created. Copy the public link or close this dialog.': 'Se creó el recurso compartido. Copia el enlace público o cierra este diálogo.',
    'Share failed.': 'No se pudo compartir.',
    'Sharing…': 'Compartiendo…',
    'Show Code': 'Mostrar código',
    'Skipped': 'Omitido',
    'Something went wrong': 'Algo salió mal',
    'Speed': 'Velocidad',
    'Start': 'Inicio',
    'Start recording': 'Iniciar grabación',
    'Started': 'Iniciado',
    'Started in {mode} mode': 'Iniciado en modo {mode}',
    'Stop and save recording': 'Detener y guardar grabación',
    "This Markdown file couldn't be rendered.": 'No se pudo renderizar este archivo Markdown.',
    'This panorama is too large to preview here.': 'Este panorama es demasiado grande para previsualizarlo aquí.',
    'Toggle expand/collapse': 'Alternar expandir/contraer',
    'Try reopening the file, or check whether the file is still available and encoded as readable text.': 'Vuelve a abrir el archivo o comprueba que siga disponible y codificado como texto legible.',
    'Unable to load the 360° preview.': 'No se pudo cargar la vista previa 360°.',
    'Untitled Event': 'Evento sin título',
    'Untitled Issue': 'Incidencia sin título',
    'Uploading files for the share link…': 'Subiendo archivos para el enlace compartido…',
    'Use: <recording path="vm:///.../voice.wav"></recording>': 'Uso: <recording path="vm:///.../voice.wav"></recording>',
    'View Artifacts': 'Ver artefactos',
    'View Messages': 'Ver mensajes',
    'View fullscreen': 'Ver en pantalla completa',
    'Waiting for a save location…': 'Esperando una ubicación de guardado…',
    'Web Browse': 'Navegación web',
    'Web Browse session': 'Sesión de navegación web',
    'Web Search': 'Búsqueda web',
    'Your shared site is published in Book.': 'Tu sitio compartido se publicó en Book.',
    'Zoom in': 'Acercar',
    'Zoom out': 'Alejar',
    'bytes': 'bytes',
    'value': 'valor',
    '{count} audio file': '{count} archivo de audio',
    '{count} audio files': '{count} archivos de audio',
    '{count} document': '{count} documento',
    '{count} documents': '{count} documentos',
    '{count} image': '{count} imagen',
    '{count} images': '{count} imágenes',
    '{count} item': '{count} elemento',
    '{count} items': '{count} elementos',
    '{count} video file': '{count} archivo de vídeo',
    '{count} video files': '{count} archivos de vídeo',
    '{count} web page': '{count} página web',
    '{count} web pages': '{count} páginas web',
  },
  'fr': {
    ' and ': ' et ',
    'Accessibility': 'Accessibilité',
    'Add preview': 'Ajouter un aperçu',
    'Add to calendar': 'Ajouter au calendrier',
    'Afternoon': 'Bon après-midi',
    'Afternoon, {name}': 'Bon après-midi, {name}',
    'Agent wants to start ComputerUse': 'L’agent veut démarrer ComputerUse',
    'Approve': 'Approuver',
    'Approved': 'Approuvé',
    'Apps in focus: {apps}': 'Apps au premier plan : {apps}',
    'Background': 'Arrière-plan',
    'Book could not publish this site.': 'Book n’a pas pu publier ce site.',
    'Book is preparing the preview before publishing.': 'Book prépare l’aperçu avant la publication.',
    'Cancel': 'Annuler',
    'Cancel queued message': 'Annuler le message en file d’attente',
    'Cancelled': 'Annulé',
    'Close': 'Fermer',
    'Close preview': 'Fermer l’aperçu',
    'Close share dialog': 'Fermer la boîte de dialogue de partage',
    'Complete login': 'Terminer la connexion',
    'Completed': 'Terminé',
    'Completing…': 'Finalisation…',
    'ComputerUse needs {permissions}.': 'ComputerUse a besoin de {permissions}.',
    'Copied': 'Copié',
    'Copied!': 'Copié !',
    'Copy': 'Copier',
    'Copy Code': 'Copier le code',
    'Copy Link': 'Copier le lien',
    'Copy Suggestion': 'Suggestion de copie',
    'Copy URL': 'Copier l’URL',
    'Copy error': 'Copier l’erreur',
    'Copy failed, please try again.': 'La copie a échoué. Veuillez réessayer.',
    'Could not publish to Book': 'Impossible de publier dans Book',
    'Create a new issue': 'Créer une nouvelle issue',
    'Create an event': 'Créer un événement',
    'Create issue': 'Créer l’issue',
    'Delete': 'Supprimer',
    'Denied': 'Refusé',
    'Deny': 'Refuser',
    'Download': 'Télécharger',
    'Download Image': 'Télécharger l’image',
    'Download diagram': 'Télécharger le diagramme',
    'Download diagram as MMD': 'Télécharger le diagramme en MMD',
    'Download diagram as PNG': 'Télécharger le diagramme en PNG',
    'Download diagram as SVG': 'Télécharger le diagramme en SVG',
    'Download file': 'Télécharger le fichier',
    'Download image': 'Télécharger l’image',
    'Duration': 'Durée',
    'End': 'Fin',
    'Enter {label}…': 'Saisissez {label}…',
    'Evening': 'Bonsoir',
    'Evening, {name}': 'Bonsoir, {name}',
    'Exit fullscreen': 'Quitter le plein écran',
    'Expired': 'Expiré',
    'Extract key points summary': 'Extraire les points clés',
    'Failed to delete schedule': 'Impossible de supprimer le planning',
    'Failed to load audio': 'Impossible de charger l’audio',
    'Failed to load image': 'Impossible de charger l’image',
    'Failed to load video': 'Impossible de charger la vidéo',
    'Failed to render Mermaid chart': 'Impossible de rendre le diagramme Mermaid',
    'Failed to save recording': 'Impossible d’enregistrer l’enregistrement',
    'Failed to save recording ({status})': 'Impossible d’enregistrer l’enregistrement ({status})',
    'Failed to start recording': 'Impossible de démarrer l’enregistrement',
    'File list': 'Liste des fichiers',
    'Foreground': 'Premier plan',
    'Generated image': 'Image générée',
    'Grant permissions': 'Accorder les permissions',
    'How can I help you today?': 'Comment puis-je vous aider aujourd’hui ?',
    'Image preview': 'Aperçu de l’image',
    'Image unavailable': 'Image indisponible',
    'Input Monitoring': 'Surveillance de la saisie',
    'Interactive login': 'Connexion interactive',
    'Interactive login completion is not available': 'La finalisation de la connexion interactive n’est pas disponible',
    'Invalid recording tag': 'Balise d’enregistrement invalide',
    'Link Copied!': 'Lien copié !',
    'Link Suggestion': 'Suggestion de lien',
    'Loading 360° preview...': 'Chargement de l’aperçu 360°...',
    'Loading browser view...': 'Chargement de la vue navigateur...',
    'Loading diagram...': 'Chargement du diagramme...',
    'Loading share preview…': 'Chargement de l’aperçu du partage…',
    'Loading…': 'Chargement…',
    'Login link expired.': 'Le lien de connexion a expiré.',
    'Manage in Book': 'Gérer dans Book',
    'Markdown preview': 'Aperçu Markdown',
    'Mermaid Error': 'Erreur Mermaid',
    'Mermaid chart': 'Diagramme Mermaid',
    'Microphone recording is not supported in this environment': 'L’enregistrement au microphone n’est pas pris en charge dans cet environnement',
    'Morning': 'Bonjour',
    'Morning, {name}': 'Bonjour, {name}',
    'Needs attention': 'Nécessite votre attention',
    'No active recording session': 'Aucune session d’enregistrement active',
    'No audio was captured': 'Aucun audio n’a été capturé',
    'No description': 'Aucune description',
    'No items selected': 'Aucun élément sélectionné',
    'No longer runs': 'Ne s’exécute plus',
    'Nothing to share yet.': 'Rien à partager pour le moment.',
    'Only supported attachments from the current assistant turn can be shared.': 'Seules les pièces jointes prises en charge du tour actuel de l’assistant peuvent être partagées.',
    'Open': 'Ouvrir',
    'Open link': 'Ouvrir le lien',
    'Open login': 'Ouvrir la connexion',
    'Opening authorization…': 'Ouverture de l’autorisation…',
    'Pause': 'Pause',
    'Paused': 'En pause',
    'Permission request': 'Demande d’autorisation',
    'Play': 'Lire',
    'Playback speed': 'Vitesse de lecture',
    'Preparing a preview of the current assistant turn…': 'Préparation d’un aperçu du tour actuel de l’assistant…',
    'Preparing preview': 'Préparation de l’aperçu',
    'Preparing share content': 'Préparation du contenu à partager',
    'Preview': 'Aperçu',
    'Preview 360° image': 'Prévisualiser l’image 360°',
    'Preview image': 'Prévisualiser l’image',
    'Preview is not available for {fileName}{mimeType}.': 'L’aperçu n’est pas disponible pour {fileName}{mimeType}.',
    'Published': 'Publié',
    'Published to Book': 'Publié dans Book',
    'Publishing to Book': 'Publication dans Book',
    'Re-record': 'Réenregistrer',
    'Recording path must end with .wav': 'Le chemin d’enregistrement doit se terminer par .wav',
    'Reset zoom and pan': 'Réinitialiser zoom et déplacement',
    'Result': 'Résultat',
    'Resume': 'Reprendre',
    'Retry': 'Réessayer',
    'Review the files before creating the share link.': 'Vérifiez les fichiers avant de créer le lien de partage.',
    'Run': 'Exécuter',
    'Save': 'Enregistrer',
    'Save File': 'Enregistrer le fichier',
    'Save Image': 'Enregistrer l’image',
    'Save completed': 'Enregistrement terminé',
    'Saved': 'Enregistré',
    'Saved to {path}': 'Enregistré dans {path}',
    'Saving...': 'Enregistrement...',
    'Schedule actions': 'Actions du planning',
    'Screen Recording': 'Enregistrement de l’écran',
    'Search with Google': 'Rechercher avec Google',
    'Select a file from chat to preview it here.': 'Sélectionnez un fichier dans le chat pour le prévisualiser ici.',
    'Sent at {time}': 'Envoyé : {time}',
    'Share': 'Partager',
    'Share Chat': 'Partager le chat',
    'Share created. Copy the public link or close this dialog.': 'Partage créé. Copiez le lien public ou fermez cette boîte de dialogue.',
    'Share failed.': 'Échec du partage.',
    'Sharing…': 'Partage…',
    'Show Code': 'Afficher le code',
    'Skipped': 'Ignoré',
    'Something went wrong': 'Une erreur est survenue',
    'Speed': 'Vitesse',
    'Start': 'Début',
    'Start recording': 'Démarrer l’enregistrement',
    'Started': 'Démarré',
    'Started in {mode} mode': 'Démarré en mode {mode}',
    'Stop and save recording': 'Arrêter et enregistrer l’enregistrement',
    "This Markdown file couldn't be rendered.": 'Ce fichier Markdown n’a pas pu être rendu.',
    'This panorama is too large to preview here.': 'Ce panorama est trop volumineux pour être prévisualisé ici.',
    'Toggle expand/collapse': 'Basculer développer/réduire',
    'Try reopening the file, or check whether the file is still available and encoded as readable text.': 'Rouvrez le fichier ou vérifiez qu’il est toujours disponible et encodé en texte lisible.',
    'Unable to load the 360° preview.': 'Impossible de charger l’aperçu 360°.',
    'Untitled Event': 'Événement sans titre',
    'Untitled Issue': 'Issue sans titre',
    'Uploading files for the share link…': 'Téléversement des fichiers pour le lien de partage…',
    'Use: <recording path="vm:///.../voice.wav"></recording>': 'Utilisation : <recording path="vm:///.../voice.wav"></recording>',
    'View Artifacts': 'Afficher les artefacts',
    'View Messages': 'Afficher les messages',
    'View fullscreen': 'Afficher en plein écran',
    'Waiting for a save location…': 'En attente d’un emplacement d’enregistrement…',
    'Web Browse': 'Navigation web',
    'Web Browse session': 'Session de navigation web',
    'Web Search': 'Recherche web',
    'Your shared site is published in Book.': 'Votre site partagé est publié dans Book.',
    'Zoom in': 'Zoom avant',
    'Zoom out': 'Zoom arrière',
    'bytes': 'octets',
    'value': 'valeur',
    '{count} audio file': '{count} fichier audio',
    '{count} audio files': '{count} fichiers audio',
    '{count} document': '{count} document',
    '{count} documents': '{count} documents',
    '{count} image': '{count} image',
    '{count} images': '{count} images',
    '{count} item': '{count} élément',
    '{count} items': '{count} éléments',
    '{count} video file': '{count} fichier vidéo',
    '{count} video files': '{count} fichiers vidéo',
    '{count} web page': '{count} page web',
    '{count} web pages': '{count} pages web',
  },
  'ja': {
    ' and ': 'と',
    'Accessibility': 'アクセシビリティ',
    'Add preview': 'プレビューを追加',
    'Add to calendar': 'カレンダーに追加',
    'Afternoon': 'こんにちは',
    'Afternoon, {name}': 'こんにちは、{name}',
    'Agent wants to start ComputerUse': 'Agent が ComputerUse を開始しようとしています',
    'Approve': '承認',
    'Approved': '承認済み',
    'Apps in focus: {apps}': 'フォーカス中のアプリ: {apps}',
    'Background': 'バックグラウンド',
    'Book could not publish this site.': 'Book はこのサイトを公開できませんでした。',
    'Book is preparing the preview before publishing.': 'Book は公開前のプレビューを準備しています。',
    'Cancel': 'キャンセル',
    'Cancel queued message': 'キュー内のメッセージをキャンセル',
    'Cancelled': 'キャンセル済み',
    'Close': '閉じる',
    'Close preview': 'プレビューを閉じる',
    'Close share dialog': '共有ダイアログを閉じる',
    'Complete login': 'ログインを完了',
    'Completed': '完了',
    'Completing…': '完了中…',
    'ComputerUse needs {permissions}.': 'ComputerUse には {permissions} が必要です。',
    'Copied': 'コピー済み',
    'Copied!': 'コピーしました！',
    'Copy': 'コピー',
    'Copy Code': 'コードをコピー',
    'Copy Link': 'リンクをコピー',
    'Copy Suggestion': 'コピーの提案',
    'Copy URL': 'URL をコピー',
    'Copy error': 'エラーをコピー',
    'Copy failed, please try again.': 'コピーに失敗しました。もう一度お試しください。',
    'Could not publish to Book': 'Book に公開できませんでした',
    'Create a new issue': '新しい Issue を作成',
    'Create an event': '予定を作成',
    'Create issue': 'Issue を作成',
    'Delete': '削除',
    'Denied': '拒否済み',
    'Deny': '拒否',
    'Download': 'ダウンロード',
    'Download Image': '画像をダウンロード',
    'Download diagram': '図をダウンロード',
    'Download diagram as MMD': 'MMD として図をダウンロード',
    'Download diagram as PNG': 'PNG として図をダウンロード',
    'Download diagram as SVG': 'SVG として図をダウンロード',
    'Download file': 'ファイルをダウンロード',
    'Download image': '画像をダウンロード',
    'Duration': '期間',
    'End': '終了',
    'Enter {label}…': '{label} を入力…',
    'Evening': 'こんばんは',
    'Evening, {name}': 'こんばんは、{name}',
    'Exit fullscreen': 'フルスクリーンを終了',
    'Expired': '期限切れ',
    'Extract key points summary': '要点の要約を抽出',
    'Failed to delete schedule': 'スケジュールを削除できませんでした',
    'Failed to load audio': '音声を読み込めませんでした',
    'Failed to load image': '画像を読み込めませんでした',
    'Failed to load video': '動画を読み込めませんでした',
    'Failed to render Mermaid chart': 'Mermaid チャートをレンダリングできませんでした',
    'Failed to save recording': '録音を保存できませんでした',
    'Failed to save recording ({status})': '録音を保存できませんでした（{status}）',
    'Failed to start recording': '録音を開始できませんでした',
    'File list': 'ファイルリスト',
    'Foreground': 'フォアグラウンド',
    'Generated image': '生成された画像',
    'Grant permissions': '権限を付与',
    'How can I help you today?': '今日はどのようなお手伝いができますか？',
    'Image preview': '画像プレビュー',
    'Image unavailable': '画像を利用できません',
    'Input Monitoring': '入力監視',
    'Interactive login': 'インタラクティブログイン',
    'Interactive login completion is not available': 'インタラクティブログインの完了は利用できません',
    'Invalid recording tag': '無効な録音タグ',
    'Link Copied!': 'リンクをコピーしました！',
    'Link Suggestion': 'リンクの提案',
    'Loading 360° preview...': '360° プレビューを読み込み中...',
    'Loading browser view...': 'ブラウザビューを読み込み中...',
    'Loading diagram...': '図を読み込み中...',
    'Loading share preview…': '共有プレビューを読み込み中…',
    'Loading…': '読み込み中…',
    'Login link expired.': 'ログインリンクの期限が切れました。',
    'Manage in Book': 'Book で管理',
    'Markdown preview': 'Markdown プレビュー',
    'Mermaid Error': 'Mermaid エラー',
    'Mermaid chart': 'Mermaid チャート',
    'Microphone recording is not supported in this environment': 'この環境ではマイク録音に対応していません',
    'Morning': 'おはようございます',
    'Morning, {name}': 'おはようございます、{name}',
    'Needs attention': '確認が必要',
    'No active recording session': 'アクティブな録音セッションがありません',
    'No audio was captured': '音声が録音されませんでした',
    'No description': '説明なし',
    'No items selected': '項目が選択されていません',
    'No longer runs': '今後は実行されません',
    'Nothing to share yet.': 'まだ共有する内容がありません。',
    'Only supported attachments from the current assistant turn can be shared.': '現在のアシスタント応答内の対応添付ファイルのみ共有できます。',
    'Open': '開く',
    'Open link': 'リンクを開く',
    'Open login': 'ログインを開く',
    'Opening authorization…': '認証を開いています…',
    'Pause': '一時停止',
    'Paused': '一時停止中',
    'Permission request': '権限リクエスト',
    'Play': '再生',
    'Playback speed': '再生速度',
    'Preparing a preview of the current assistant turn…': '現在のアシスタント応答のプレビューを準備しています…',
    'Preparing preview': 'プレビューを準備中',
    'Preparing share content': '共有コンテンツを準備中',
    'Preview': 'プレビュー',
    'Preview 360° image': '360° 画像をプレビュー',
    'Preview image': '画像をプレビュー',
    'Preview is not available for {fileName}{mimeType}.': '{fileName}{mimeType} はプレビューできません。',
    'Published': '公開済み',
    'Published to Book': 'Book に公開済み',
    'Publishing to Book': 'Book に公開中',
    'Re-record': '再録音',
    'Recording path must end with .wav': '録音パスは .wav で終わる必要があります',
    'Reset zoom and pan': 'ズームとパンをリセット',
    'Result': '結果',
    'Resume': '再開',
    'Retry': '再試行',
    'Review the files before creating the share link.': '共有リンクを作成する前にファイルを確認してください。',
    'Run': '実行',
    'Save': '保存',
    'Save File': 'ファイルを保存',
    'Save Image': '画像を保存',
    'Save completed': '保存が完了しました',
    'Saved': '保存済み',
    'Saved to {path}': '{path} に保存しました',
    'Saving...': '保存中...',
    'Schedule actions': 'スケジュール操作',
    'Screen Recording': '画面収録',
    'Search with Google': 'Google で検索',
    'Select a file from chat to preview it here.': 'チャットからファイルを選択すると、ここでプレビューできます。',
    'Sent at {time}': '送信日時：{time}',
    'Share': '共有',
    'Share Chat': 'チャットを共有',
    'Share created. Copy the public link or close this dialog.': '共有が作成されました。公開リンクをコピーするか、このダイアログを閉じてください。',
    'Share failed.': '共有に失敗しました。',
    'Sharing…': '共有中…',
    'Show Code': 'コードを表示',
    'Skipped': 'スキップ済み',
    'Something went wrong': '問題が発生しました',
    'Speed': '速度',
    'Start': '開始',
    'Start recording': '録音を開始',
    'Started': '開始済み',
    'Started in {mode} mode': '{mode} モードで開始しました',
    'Stop and save recording': '録音を停止して保存',
    "This Markdown file couldn't be rendered.": 'この Markdown ファイルをレンダリングできませんでした。',
    'This panorama is too large to preview here.': 'このパノラマは大きすぎるため、ここではプレビューできません。',
    'Toggle expand/collapse': '展開/折りたたみを切り替え',
    'Try reopening the file, or check whether the file is still available and encoded as readable text.': 'ファイルを開き直すか、ファイルがまだ利用可能で読み取り可能なテキストとしてエンコードされているか確認してください。',
    'Unable to load the 360° preview.': '360° プレビューを読み込めません。',
    'Untitled Event': '無題の予定',
    'Untitled Issue': '無題の Issue',
    'Uploading files for the share link…': '共有リンク用にファイルをアップロードしています…',
    'Use: <recording path="vm:///.../voice.wav"></recording>': '使用方法: <recording path="vm:///.../voice.wav"></recording>',
    'View Artifacts': '成果物を表示',
    'View Messages': 'メッセージを表示',
    'View fullscreen': 'フルスクリーンで表示',
    'Waiting for a save location…': '保存先を待機中…',
    'Web Browse': 'Web ブラウズ',
    'Web Browse session': 'Web ブラウズセッション',
    'Web Search': 'Web 検索',
    'Your shared site is published in Book.': '共有サイトが Book に公開されました。',
    'Zoom in': 'ズームイン',
    'Zoom out': 'ズームアウト',
    'bytes': 'バイト',
    'value': '値',
    '{count} audio file': '{count} 件の音声ファイル',
    '{count} audio files': '{count} 件の音声ファイル',
    '{count} document': '{count} 件のドキュメント',
    '{count} documents': '{count} 件のドキュメント',
    '{count} image': '{count} 件の画像',
    '{count} images': '{count} 件の画像',
    '{count} item': '{count} 件',
    '{count} items': '{count} 件',
    '{count} video file': '{count} 件の動画ファイル',
    '{count} video files': '{count} 件の動画ファイル',
    '{count} web page': '{count} 件のウェブページ',
    '{count} web pages': '{count} 件のウェブページ',
  },
  'ko': {
    ' and ': ' 및 ',
    'Accessibility': '손쉬운 사용',
    'Add preview': '미리보기 추가',
    'Add to calendar': '캘린더에 추가',
    'Afternoon': '좋은 오후예요',
    'Afternoon, {name}': '좋은 오후예요, {name}',
    'Agent wants to start ComputerUse': 'Agent가 ComputerUse를 시작하려고 합니다',
    'Approve': '승인',
    'Approved': '승인됨',
    'Apps in focus: {apps}': '포커스된 앱: {apps}',
    'Background': '백그라운드',
    'Book could not publish this site.': 'Book에서 이 사이트를 게시하지 못했습니다.',
    'Book is preparing the preview before publishing.': 'Book에서 게시 전 미리보기를 준비 중입니다.',
    'Cancel': '취소',
    'Cancel queued message': '대기 중인 메시지 취소',
    'Cancelled': '취소됨',
    'Close': '닫기',
    'Close preview': '미리보기 닫기',
    'Close share dialog': '공유 대화상자 닫기',
    'Complete login': '로그인 완료',
    'Completed': '완료됨',
    'Completing…': '완료 중…',
    'ComputerUse needs {permissions}.': 'ComputerUse에 {permissions} 권한이 필요합니다.',
    'Copied': '복사됨',
    'Copied!': '복사됨!',
    'Copy': '복사',
    'Copy Code': '코드 복사',
    'Copy Link': '링크 복사',
    'Copy Suggestion': '복사 제안',
    'Copy URL': 'URL 복사',
    'Copy error': '오류 복사',
    'Copy failed, please try again.': '복사하지 못했습니다. 다시 시도하세요.',
    'Could not publish to Book': 'Book에 게시하지 못했습니다',
    'Create a new issue': '새 Issue 만들기',
    'Create an event': '일정 만들기',
    'Create issue': 'Issue 만들기',
    'Delete': '삭제',
    'Denied': '거부됨',
    'Deny': '거부',
    'Download': '다운로드',
    'Download Image': '이미지 다운로드',
    'Download diagram': '다이어그램 다운로드',
    'Download diagram as MMD': 'MMD로 다이어그램 다운로드',
    'Download diagram as PNG': 'PNG로 다이어그램 다운로드',
    'Download diagram as SVG': 'SVG로 다이어그램 다운로드',
    'Download file': '파일 다운로드',
    'Download image': '이미지 다운로드',
    'Duration': '기간',
    'End': '종료',
    'Enter {label}…': '{label} 입력…',
    'Evening': '좋은 저녁이에요',
    'Evening, {name}': '좋은 저녁이에요, {name}',
    'Exit fullscreen': '전체 화면 종료',
    'Expired': '만료됨',
    'Extract key points summary': '핵심 요약 추출',
    'Failed to delete schedule': '일정을 삭제하지 못했습니다',
    'Failed to load audio': '오디오를 불러오지 못했습니다',
    'Failed to load image': '이미지를 불러오지 못했습니다',
    'Failed to load video': '비디오를 불러오지 못했습니다',
    'Failed to render Mermaid chart': 'Mermaid 차트를 렌더링하지 못했습니다',
    'Failed to save recording': '녹음을 저장하지 못했습니다',
    'Failed to save recording ({status})': '녹음을 저장하지 못했습니다({status})',
    'Failed to start recording': '녹음을 시작하지 못했습니다',
    'File list': '파일 목록',
    'Foreground': '포그라운드',
    'Generated image': '생성된 이미지',
    'Grant permissions': '권한 부여',
    'How can I help you today?': '오늘 무엇을 도와드릴까요?',
    'Image preview': '이미지 미리보기',
    'Image unavailable': '이미지를 사용할 수 없습니다',
    'Input Monitoring': '입력 모니터링',
    'Interactive login': '대화형 로그인',
    'Interactive login completion is not available': '대화형 로그인 완료를 사용할 수 없습니다',
    'Invalid recording tag': '잘못된 녹음 태그',
    'Link Copied!': '링크를 복사했습니다!',
    'Link Suggestion': '링크 제안',
    'Loading 360° preview...': '360° 미리보기 로드 중...',
    'Loading browser view...': '브라우저 보기를 불러오는 중...',
    'Loading diagram...': '다이어그램을 불러오는 중...',
    'Loading share preview…': '공유 미리보기를 로드 중…',
    'Loading…': '로드 중…',
    'Login link expired.': '로그인 링크가 만료되었습니다.',
    'Manage in Book': 'Book에서 관리',
    'Markdown preview': 'Markdown 미리보기',
    'Mermaid Error': 'Mermaid 오류',
    'Mermaid chart': 'Mermaid 차트',
    'Microphone recording is not supported in this environment': '이 환경에서는 마이크 녹음이 지원되지 않습니다',
    'Morning': '좋은 아침이에요',
    'Morning, {name}': '좋은 아침이에요, {name}',
    'Needs attention': '확인 필요',
    'No active recording session': '활성 녹음 세션이 없습니다',
    'No audio was captured': '캡처된 오디오가 없습니다',
    'No description': '설명 없음',
    'No items selected': '선택된 항목 없음',
    'No longer runs': '더 이상 실행되지 않음',
    'Nothing to share yet.': '아직 공유할 내용이 없습니다.',
    'Only supported attachments from the current assistant turn can be shared.': '현재 어시스턴트 응답의 지원되는 첨부 파일만 공유할 수 있습니다.',
    'Open': '열기',
    'Open link': '링크 열기',
    'Open login': '로그인 열기',
    'Opening authorization…': '권한 부여 여는 중…',
    'Pause': '일시 정지',
    'Paused': '일시 정지됨',
    'Permission request': '권한 요청',
    'Play': '재생',
    'Playback speed': '재생 속도',
    'Preparing a preview of the current assistant turn…': '현재 어시스턴트 응답 미리보기를 준비 중…',
    'Preparing preview': '미리보기 준비 중',
    'Preparing share content': '공유 콘텐츠 준비 중',
    'Preview': '미리보기',
    'Preview 360° image': '360° 이미지 미리보기',
    'Preview image': '이미지 미리보기',
    'Preview is not available for {fileName}{mimeType}.': '{fileName}{mimeType}은(는) 미리 볼 수 없습니다.',
    'Published': '게시됨',
    'Published to Book': 'Book에 게시됨',
    'Publishing to Book': 'Book에 게시 중',
    'Re-record': '다시 녹음',
    'Recording path must end with .wav': '녹음 경로는 .wav로 끝나야 합니다',
    'Reset zoom and pan': '확대/이동 재설정',
    'Result': '결과',
    'Resume': '재개',
    'Retry': '다시 시도',
    'Review the files before creating the share link.': '공유 링크를 만들기 전에 파일을 검토하세요.',
    'Run': '실행',
    'Save': '저장',
    'Save File': '파일 저장',
    'Save Image': '이미지 저장',
    'Save completed': '저장 완료',
    'Saved': '저장됨',
    'Saved to {path}': '{path}에 저장됨',
    'Saving...': '저장 중...',
    'Schedule actions': '일정 작업',
    'Screen Recording': '화면 기록',
    'Search with Google': 'Google로 검색',
    'Select a file from chat to preview it here.': '채팅에서 파일을 선택하면 여기에서 미리 볼 수 있습니다.',
    'Sent at {time}': '전송 시간: {time}',
    'Share': '공유',
    'Share Chat': '채팅 공유',
    'Share created. Copy the public link or close this dialog.': '공유가 생성되었습니다. 공개 링크를 복사하거나 이 대화상자를 닫으세요.',
    'Share failed.': '공유 실패.',
    'Sharing…': '공유 중…',
    'Show Code': '코드 보기',
    'Skipped': '건너뜀',
    'Something went wrong': '문제가 발생했습니다',
    'Speed': '속도',
    'Start': '시작',
    'Start recording': '녹음 시작',
    'Started': '시작됨',
    'Started in {mode} mode': '{mode} 모드로 시작됨',
    'Stop and save recording': '녹음 중지 및 저장',
    "This Markdown file couldn't be rendered.": '이 Markdown 파일을 렌더링할 수 없습니다.',
    'This panorama is too large to preview here.': '이 파노라마는 너무 커서 여기에서 미리 볼 수 없습니다.',
    'Toggle expand/collapse': '펼치기/접기 전환',
    'Try reopening the file, or check whether the file is still available and encoded as readable text.': '파일을 다시 열어 보거나 파일이 아직 사용 가능하고 읽을 수 있는 텍스트로 인코딩되어 있는지 확인하세요.',
    'Unable to load the 360° preview.': '360° 미리보기를 불러올 수 없습니다.',
    'Untitled Event': '제목 없는 일정',
    'Untitled Issue': '제목 없는 Issue',
    'Uploading files for the share link…': '공유 링크용 파일을 업로드하는 중…',
    'Use: <recording path="vm:///.../voice.wav"></recording>': '사용법: <recording path="vm:///.../voice.wav"></recording>',
    'View Artifacts': '아티팩트 보기',
    'View Messages': '메시지 보기',
    'View fullscreen': '전체 화면 보기',
    'Waiting for a save location…': '저장 위치를 기다리는 중…',
    'Web Browse': '웹 탐색',
    'Web Browse session': '웹 탐색 세션',
    'Web Search': '웹 검색',
    'Your shared site is published in Book.': '공유한 사이트가 Book에 게시되었습니다.',
    'Zoom in': '확대',
    'Zoom out': '축소',
    'bytes': '바이트',
    'value': '값',
    '{count} audio file': '{count}개 오디오 파일',
    '{count} audio files': '{count}개 오디오 파일',
    '{count} document': '{count}개 문서',
    '{count} documents': '{count}개 문서',
    '{count} image': '{count}개 이미지',
    '{count} images': '{count}개 이미지',
    '{count} item': '항목 {count}개',
    '{count} items': '항목 {count}개',
    '{count} video file': '{count}개 동영상 파일',
    '{count} video files': '{count}개 동영상 파일',
    '{count} web page': '{count}개 웹 페이지',
    '{count} web pages': '{count}개 웹 페이지',
  },
  'zh-Hans': {
    ' and ': '和',
    'Accessibility': '辅助功能',
    'Add preview': '添加预览',
    'Add to calendar': '添加到日历',
    'Afternoon': '下午好',
    'Afternoon, {name}': '下午好，{name}',
    'Agent wants to start ComputerUse': 'Agent 想要启动 ComputerUse',
    'Approve': '批准',
    'Approved': '已批准',
    'Apps in focus: {apps}': '当前聚焦的应用：{apps}',
    'Background': '后台',
    'Book could not publish this site.': 'Book 无法发布此站点。',
    'Book is preparing the preview before publishing.': 'Book 正在发布前准备预览。',
    'Cancel': '取消',
    'Cancel queued message': '取消排队消息',
    'Cancelled': '已取消',
    'Close': '关闭',
    'Close preview': '关闭预览',
    'Close share dialog': '关闭分享对话框',
    'Complete login': '完成登录',
    'Completed': '已完成',
    'Completing…': '正在完成…',
    'ComputerUse needs {permissions}.': 'ComputerUse 需要{permissions}权限。',
    'Copied': '已复制',
    'Copied!': '已复制！',
    'Copy': '复制',
    'Copy Code': '复制代码',
    'Copy Link': '复制链接',
    'Copy Suggestion': '复制建议',
    'Copy URL': '复制 URL',
    'Copy error': '复制错误',
    'Copy failed, please try again.': '复制失败，请重试。',
    'Could not publish to Book': '无法发布到 Book',
    'Create a new issue': '创建新 Issue',
    'Create an event': '创建日程',
    'Create issue': '创建 Issue',
    'Delete': '删除',
    'Denied': '已拒绝',
    'Deny': '拒绝',
    'Download': '下载',
    'Download Image': '下载图片',
    'Download diagram': '下载图表',
    'Download diagram as MMD': '下载 MMD 图表',
    'Download diagram as PNG': '下载 PNG 图表',
    'Download diagram as SVG': '下载 SVG 图表',
    'Download file': '下载文件',
    'Download image': '下载图片',
    'Duration': '持续时间',
    'End': '结束',
    'Enter {label}…': '输入{label}…',
    'Evening': '晚上好',
    'Evening, {name}': '晚上好，{name}',
    'Exit fullscreen': '退出全屏',
    'Expired': '已过期',
    'Extract key points summary': '提取重点摘要',
    'Failed to delete schedule': '删除计划失败',
    'Failed to load audio': '加载音频失败',
    'Failed to load image': '加载图像失败',
    'Failed to load video': '加载视频失败',
    'Failed to render Mermaid chart': '渲染 Mermaid 图表失败',
    'Failed to save recording': '保存录音失败',
    'Failed to save recording ({status})': '保存录音失败（{status}）',
    'Failed to start recording': '启动录音失败',
    'File list': '文件列表',
    'Foreground': '前台',
    'Generated image': '生成的图像',
    'Grant permissions': '授予权限',
    'How can I help you today?': '今天有什么可以帮你的？',
    'Image preview': '图片预览',
    'Image unavailable': '图片不可用',
    'Input Monitoring': '输入监控',
    'Interactive login': '交互式登录',
    'Interactive login completion is not available': '交互式登录完成不可用',
    'Invalid recording tag': '无效的录音标签',
    'Link Copied!': '链接已复制！',
    'Link Suggestion': '链接建议',
    'Loading 360° preview...': '正在加载 360° 预览...',
    'Loading browser view...': '正在加载浏览器视图...',
    'Loading diagram...': '正在加载图表...',
    'Loading share preview…': '正在加载分享预览…',
    'Loading…': '加载中…',
    'Login link expired.': '登录链接已过期。',
    'Manage in Book': '在 Book 中管理',
    'Markdown preview': 'Markdown 预览',
    'Mermaid Error': 'Mermaid 错误',
    'Mermaid chart': 'Mermaid 图表',
    'Microphone recording is not supported in this environment': '此环境不支持麦克风录音',
    'Morning': '早上好',
    'Morning, {name}': '早上好，{name}',
    'Needs attention': '需要处理',
    'No active recording session': '没有活动的录音会话',
    'No audio was captured': '未捕获到音频',
    'No description': '无描述',
    'No items selected': '未选择项目',
    'No longer runs': '不再运行',
    'Nothing to share yet.': '暂时没有可分享内容。',
    'Only supported attachments from the current assistant turn can be shared.': '只能分享当前助手回复中的受支持附件。',
    'Open': '打开',
    'Open link': '打开链接',
    'Open login': '打开登录',
    'Opening authorization…': '正在打开授权…',
    'Pause': '暂停',
    'Paused': '已暂停',
    'Permission request': '权限请求',
    'Play': '播放',
    'Playback speed': '播放速度',
    'Preparing a preview of the current assistant turn…': '正在准备当前助手回复的预览…',
    'Preparing preview': '正在准备预览',
    'Preparing share content': '正在准备分享内容',
    'Preview': '预览',
    'Preview 360° image': '预览 360° 图片',
    'Preview image': '预览图片',
    'Preview is not available for {fileName}{mimeType}.': '无法预览 {fileName}{mimeType}。',
    'Published': '已发布',
    'Published to Book': '已发布到 Book',
    'Publishing to Book': '正在发布到 Book',
    'Re-record': '重新录制',
    'Recording path must end with .wav': '录音路径必须以 .wav 结尾',
    'Reset zoom and pan': '重置缩放和平移',
    'Result': '结果',
    'Resume': '继续',
    'Retry': '重试',
    'Review the files before creating the share link.': '创建分享链接前，请检查文件。',
    'Run': '运行',
    'Save': '保存',
    'Save File': '保存文件',
    'Save Image': '保存图像',
    'Save completed': '保存完成',
    'Saved': '已保存',
    'Saved to {path}': '已保存到 {path}',
    'Saving...': '正在保存...',
    'Schedule actions': '计划操作',
    'Screen Recording': '屏幕录制',
    'Search with Google': '用 Google 搜索',
    'Select a file from chat to preview it here.': '从聊天中选择一个文件在这里预览。',
    'Sent at {time}': '发送时间：{time}',
    'Share': '分享',
    'Share Chat': '分享聊天',
    'Share created. Copy the public link or close this dialog.': '分享已创建。复制公开链接或关闭此对话框。',
    'Share failed.': '分享失败。',
    'Sharing…': '正在分享…',
    'Show Code': '显示代码',
    'Skipped': '已跳过',
    'Something went wrong': '出错了',
    'Speed': '速度',
    'Start': '开始',
    'Start recording': '开始录音',
    'Started': '已启动',
    'Started in {mode} mode': '已以{mode}模式启动',
    'Stop and save recording': '停止并保存录音',
    "This Markdown file couldn't be rendered.": '无法渲染这个 Markdown 文件。',
    'This panorama is too large to preview here.': '此全景图太大，无法在这里预览。',
    'Toggle expand/collapse': '切换展开/折叠',
    'Try reopening the file, or check whether the file is still available and encoded as readable text.': '请尝试重新打开文件，或检查文件是否仍可用且编码为可读文本。',
    'Unable to load the 360° preview.': '无法加载 360° 预览。',
    'Untitled Event': '未命名日程',
    'Untitled Issue': '未命名 Issue',
    'Uploading files for the share link…': '正在为分享链接上传文件…',
    'Use: <recording path="vm:///.../voice.wav"></recording>': '用法：<recording path="vm:///.../voice.wav"></recording>',
    'View Artifacts': '查看产物',
    'View Messages': '查看消息',
    'View fullscreen': '全屏查看',
    'Waiting for a save location…': '正在等待保存位置…',
    'Web Browse': '网页浏览',
    'Web Browse session': '网页浏览会话',
    'Web Search': '网页搜索',
    'Your shared site is published in Book.': '你的分享站点已发布到 Book。',
    'Zoom in': '放大',
    'Zoom out': '缩小',
    'bytes': '字节',
    'value': '值',
    '{count} audio file': '{count} 个音频文件',
    '{count} audio files': '{count} 个音频文件',
    '{count} document': '{count} 个文档',
    '{count} documents': '{count} 个文档',
    '{count} image': '{count} 张图片',
    '{count} images': '{count} 张图片',
    '{count} item': '{count} 个项目',
    '{count} items': '{count} 个项目',
    '{count} video file': '{count} 个视频文件',
    '{count} video files': '{count} 个视频文件',
    '{count} web page': '{count} 个网页',
    '{count} web pages': '{count} 个网页',
  },
  'zh-Hant': {
    ' and ': '和',
    'Accessibility': '輔助使用',
    'Add preview': '新增預覽',
    'Add to calendar': '加入行事曆',
    'Afternoon': '午安',
    'Afternoon, {name}': '午安，{name}',
    'Agent wants to start ComputerUse': 'Agent 想要啟動 ComputerUse',
    'Approve': '核准',
    'Approved': '已核准',
    'Apps in focus: {apps}': '目前焦點中的 App：{apps}',
    'Background': '背景',
    'Book could not publish this site.': 'Book 無法發佈此網站。',
    'Book is preparing the preview before publishing.': 'Book 正在發佈前準備預覽。',
    'Cancel': '取消',
    'Cancel queued message': '取消佇列中的訊息',
    'Cancelled': '已取消',
    'Close': '關閉',
    'Close preview': '關閉預覽',
    'Close share dialog': '關閉分享對話框',
    'Complete login': '完成登入',
    'Completed': '已完成',
    'Completing…': '正在完成…',
    'ComputerUse needs {permissions}.': 'ComputerUse 需要{permissions}權限。',
    'Copied': '已複製',
    'Copied!': '已複製！',
    'Copy': '複製',
    'Copy Code': '複製程式碼',
    'Copy Link': '複製連結',
    'Copy Suggestion': '複製建議',
    'Copy URL': '複製 URL',
    'Copy error': '複製錯誤',
    'Copy failed, please try again.': '複製失敗，請再試一次。',
    'Could not publish to Book': '無法發佈到 Book',
    'Create a new issue': '建立新 Issue',
    'Create an event': '建立行程',
    'Create issue': '建立 Issue',
    'Delete': '刪除',
    'Denied': '已拒絕',
    'Deny': '拒絕',
    'Download': '下載',
    'Download Image': '下載圖片',
    'Download diagram': '下載圖表',
    'Download diagram as MMD': '下載 MMD 圖表',
    'Download diagram as PNG': '下載 PNG 圖表',
    'Download diagram as SVG': '下載 SVG 圖表',
    'Download file': '下載檔案',
    'Download image': '下載圖片',
    'Duration': '持續時間',
    'End': '結束',
    'Enter {label}…': '輸入{label}…',
    'Evening': '晚安',
    'Evening, {name}': '晚安，{name}',
    'Exit fullscreen': '退出全螢幕',
    'Expired': '已過期',
    'Extract key points summary': '擷取重點摘要',
    'Failed to delete schedule': '刪除排程失敗',
    'Failed to load audio': '載入音訊失敗',
    'Failed to load image': '載入圖片失敗',
    'Failed to load video': '載入影片失敗',
    'Failed to render Mermaid chart': '渲染 Mermaid 圖表失敗',
    'Failed to save recording': '儲存錄音失敗',
    'Failed to save recording ({status})': '儲存錄音失敗（{status}）',
    'Failed to start recording': '啟動錄音失敗',
    'File list': '檔案列表',
    'Foreground': '前景',
    'Generated image': '產生的圖片',
    'Grant permissions': '授予權限',
    'How can I help you today?': '今天有什麼可以幫你的？',
    'Image preview': '圖片預覽',
    'Image unavailable': '圖片無法使用',
    'Input Monitoring': '輸入監控',
    'Interactive login': '互動式登入',
    'Interactive login completion is not available': '無法完成互動式登入',
    'Invalid recording tag': '無效的錄音標籤',
    'Link Copied!': '連結已複製！',
    'Link Suggestion': '連結建議',
    'Loading 360° preview...': '正在載入 360° 預覽...',
    'Loading browser view...': '正在載入瀏覽器檢視...',
    'Loading diagram...': '正在載入圖表...',
    'Loading share preview…': '正在載入分享預覽…',
    'Loading…': '載入中…',
    'Login link expired.': '登入連結已過期。',
    'Manage in Book': '在 Book 中管理',
    'Markdown preview': 'Markdown 預覽',
    'Mermaid Error': 'Mermaid 錯誤',
    'Mermaid chart': 'Mermaid 圖表',
    'Microphone recording is not supported in this environment': '此環境不支援麥克風錄音',
    'Morning': '早安',
    'Morning, {name}': '早安，{name}',
    'Needs attention': '需要注意',
    'No active recording session': '沒有作用中的錄音工作階段',
    'No audio was captured': '未擷取到音訊',
    'No description': '沒有描述',
    'No items selected': '未選取項目',
    'No longer runs': '不再執行',
    'Nothing to share yet.': '暫時沒有可分享內容。',
    'Only supported attachments from the current assistant turn can be shared.': '只能分享目前助理回覆中的受支援附件。',
    'Open': '開啟',
    'Open link': '開啟連結',
    'Open login': '開啟登入',
    'Opening authorization…': '正在開啟授權…',
    'Pause': '暫停',
    'Paused': '已暫停',
    'Permission request': '權限要求',
    'Play': '播放',
    'Playback speed': '播放速度',
    'Preparing a preview of the current assistant turn…': '正在準備目前助理回覆的預覽…',
    'Preparing preview': '正在準備預覽',
    'Preparing share content': '正在準備分享內容',
    'Preview': '預覽',
    'Preview 360° image': '預覽 360° 圖片',
    'Preview image': '預覽圖片',
    'Preview is not available for {fileName}{mimeType}.': '無法預覽 {fileName}{mimeType}。',
    'Published': '已發佈',
    'Published to Book': '已發佈到 Book',
    'Publishing to Book': '正在發佈到 Book',
    'Re-record': '重新錄製',
    'Recording path must end with .wav': '錄音路徑必須以 .wav 結尾',
    'Reset zoom and pan': '重設縮放與平移',
    'Result': '結果',
    'Resume': '繼續',
    'Retry': '重試',
    'Review the files before creating the share link.': '建立分享連結前，請檢查檔案。',
    'Run': '執行',
    'Save': '儲存',
    'Save File': '儲存檔案',
    'Save Image': '儲存圖片',
    'Save completed': '儲存完成',
    'Saved': '已儲存',
    'Saved to {path}': '已儲存到 {path}',
    'Saving...': '正在儲存...',
    'Schedule actions': '排程操作',
    'Screen Recording': '螢幕錄影',
    'Search with Google': '用 Google 搜尋',
    'Select a file from chat to preview it here.': '從聊天中選擇一個檔案在這裡預覽。',
    'Sent at {time}': '傳送時間：{time}',
    'Share': '分享',
    'Share Chat': '分享對話',
    'Share created. Copy the public link or close this dialog.': '分享已建立。複製公開連結或關閉此對話框。',
    'Share failed.': '分享失敗。',
    'Sharing…': '正在分享…',
    'Show Code': '顯示程式碼',
    'Skipped': '已略過',
    'Something went wrong': '發生錯誤',
    'Speed': '速度',
    'Start': '開始',
    'Start recording': '開始錄音',
    'Started': '已啟動',
    'Started in {mode} mode': '已以{mode}模式啟動',
    'Stop and save recording': '停止並儲存錄音',
    "This Markdown file couldn't be rendered.": '無法算繪這個 Markdown 檔案。',
    'This panorama is too large to preview here.': '此全景圖太大，無法在這裡預覽。',
    'Toggle expand/collapse': '切換展開/收合',
    'Try reopening the file, or check whether the file is still available and encoded as readable text.': '請嘗試重新開啟檔案，或檢查檔案是否仍可用且編碼為可讀文字。',
    'Unable to load the 360° preview.': '無法載入 360° 預覽。',
    'Untitled Event': '未命名行程',
    'Untitled Issue': '未命名 Issue',
    'Uploading files for the share link…': '正在為分享連結上傳檔案…',
    'Use: <recording path="vm:///.../voice.wav"></recording>': '用法：<recording path="vm:///.../voice.wav"></recording>',
    'View Artifacts': '查看產物',
    'View Messages': '查看訊息',
    'View fullscreen': '全螢幕檢視',
    'Waiting for a save location…': '正在等待儲存位置…',
    'Web Browse': '網頁瀏覽',
    'Web Browse session': '網頁瀏覽工作階段',
    'Web Search': '網頁搜尋',
    'Your shared site is published in Book.': '你的分享網站已發佈到 Book。',
    'Zoom in': '放大',
    'Zoom out': '縮小',
    'bytes': '位元組',
    'value': '值',
    '{count} audio file': '{count} 個音訊檔案',
    '{count} audio files': '{count} 個音訊檔案',
    '{count} document': '{count} 份文件',
    '{count} documents': '{count} 份文件',
    '{count} image': '{count} 張圖片',
    '{count} images': '{count} 張圖片',
    '{count} item': '{count} 個項目',
    '{count} items': '{count} 個項目',
    '{count} video file': '{count} 個影片檔案',
    '{count} video files': '{count} 個影片檔案',
    '{count} web page': '{count} 個網頁',
    '{count} web pages': '{count} 個網頁',
  },
} as const satisfies Record<string, I18nTranslations>;

export type I18nLocale = keyof typeof i18nTranslations;
